export function JdPriorSends({
  items,
}: {
  items: {
    fieldId: string;
    fieldName: string;
    product: string;
    sentAt: string;
    fileId: string | null;
  }[];
}) {
  if (!items.length) return null;
  return (
    <div className="rounded border border-amber-500/40 bg-amber-500/5 p-2 text-[11px]">
      <span className="block font-medium text-fg">Already sent before</span>
      <ul className="mt-0.5 space-y-0.5 text-[10px] leading-snug text-muted">
        {items.map((item) => (
          <li key={item.fieldId}>
            {item.fieldName} — {item.product} sent{" "}
            {new Date(item.sentAt).toLocaleDateString()}
            {item.fileId ? ` (JD file ${item.fileId})` : ""}. Sending again
            creates a NEW file in Ops Center — it never replaces the old one.
          </li>
        ))}
      </ul>
    </div>
  );
}
